import type { NovaEmbedContext } from '../../../lib/embed-context';
import { MessageResponse } from '../../ai-elements/message-response';

/** The embedding host's view a chat opens on, rendered through the hardened markdown pipeline. */
export function EmbedContextView({ embedContext }: { embedContext: NovaEmbedContext }) {
  return (
    <section
      aria-label="Context from the page you opened Nova on"
      data-testid="nova-embed-context"
      className="border-steel-200 rounded-lg border bg-white p-4"
    >
      <MessageResponse>{embedContext.markdown}</MessageResponse>
    </section>
  );
}
